import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ExamsService } from './exams.service';
import { PatientsService } from './patients.service';
import { Subject } from 'rxjs';
import { by } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class PathologyService {

  pathologyForm: UntypedFormGroup;
  pathologies:any =[];
  loaded: Subject<null> = new Subject();

  constructor(private fb:UntypedFormBuilder, private http:HttpClient, private es:ExamsService, public pat:PatientsService) {
    this.resetForm();
    if(es.isClosed){
      this.pathologyForm.disable({emitEvent:false})
    }
   }
  /**
   * Formats start and end dates as SQL strings, with end date set to 23:59:59
   */
  private getSqlDateRange(start: Date, end: Date): { startSql: string, endSql: string } {
    const pad = (n: number) => n.toString().padStart(2, '0');
     const formatDate = (d: Date, time: string) => {
      try{
        return `${d['_i'].year}-${pad(d['_i'].month + 1)}-${pad(d['_i'].date)}`;
      }
      catch{//the dates are Date format
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
      }
    };
     
      return {
        startSql: formatDate(start, '00:00:00'),
        endSql: formatDate(end, '23:59:59')
      };
    
  }

   resetForm(){
     this.pathologyForm = this.fb.group({
      Type:[''],
      BarCode:[''],
      Comments:[''],
     })
   }

   getPathologies(){
     this.pathologies = [];
     this.http.get(`/api/gastro/getPathology/${this.es.examID}`).subscribe((data) => {
       this.pathologies = data;
       this.loaded.next(null);
     })
   }

   save(){
    this.http.post(`/api/gastro/savePathology/${this.es.examID}` ,{pathology: this.pathologyForm.value, pat: this.pat.getPat()}).subscribe((data) => {
      this.getPathologies();
      this.pathologyForm.reset()
    })
    
   }
   delete(path){
     if(this.es.isClosed)
      return;
    this.http.post(`/api/gastro/deletePathology`, {pathology: path}).subscribe((data) => {
      this.getPathologies();
    })
    
  }

  hasLab(){
    for(let p of this.pathologies){
      if(p.LabReport)
        return true;
    }
    return false;
  }

  saveComment(comment: string, labresultid: number) {
    this.http.post(`/api/gastro/saveComment/${labresultid}`, { comment }).subscribe((data) => {
     //this.getPathologies();
    });
  }

  markAsReviewed(autoIndex: number) {
    return this.http.post(`/api/gastro/markAsReviewed/${autoIndex}`, {});
  }
  
  getBioPolyStatsForColonoscopy(
    report: string,
    startdate: Date,
    enddate: Date,
    HMO: string = null,
  ) {
    //the start and end dates should be date stings like yyyy-mm-dd without breaking timezone which toISOstring does
    const { startSql, endSql } = this.getSqlDateRange(startdate, enddate);
    return this.http.get(
      `/api/gastro/getBiopsyStats/${report}/${startSql}/${endSql}`,
    );
  }

  getBiopsyStats( startdate: Date, enddate: Date, HMO: string){ 
    //the start and end dates should be date stings like yyyy-mm-dd without breaking timezone which toISOstring does
    const { startSql, endSql } = this.getSqlDateRange(startdate, enddate);
    //return this.http.get(`/api/gastro/getBiopsyStats/${report}/${startSql}/${endSql}`);
    return this.http.get(`/api/lab/biopsyStats/${startSql}/${endSql}` + (HMO ? `/${HMO}` : ''));
  }

  signSampleDetails(inventoryid, pathologyids: number[], userType, UID){
    return this.http.post('/api/lab/signPathologyDetails', {inventory: inventoryid, 'pathologyids': pathologyids, 'usertype': userType, 'UID': UID});
  }

  makeMessengerReport(pathologyids: number[], lab:string) {
    return this.http.post('/api/lab/makeMessengerReport', { 'pathologies': pathologyids, 'lab': lab });
  }

  prepPathologies(inventoryid: number){
    return this.http.get('/api/lab/samplelist/' + inventoryid);
  }

  signInventory(inventoryID, UID, usertype){
    return this.http.post('/api/lab/signMessengerReport', {inventory: inventoryID, UID: UID, usertype: usertype});
  }

  getActiveInventories(page?: number, pageSize?: number) {
    let params: any = {};
    if (page) {
      params.page = page;
    }
    if (pageSize) {
      params.pageSize = pageSize;
    }
    return this.http.get("/api/lab/getActiveInventories", { params: params });
  }

  getInventoryDetails(inventoryID: number, code: string = null){
    return this.http.get('/api/lab/getInventoryDetails/' + inventoryID + (code ? '/' + code : ''));
  }

  sendMessengerSignature(inventoryId: number, messengerName: string, messengerSignature: string){
    //messengerSignature is a base64 image and the response is binary pdf
    return this.http.post('/api/lab/sendMessengerSignature', {inventoryID: inventoryId, messengerName: messengerName, signatureImage: messengerSignature}, { responseType: 'blob' });
  }

  getCompletedInventories(
    startDate: Date = null,
    endDate: Date = null,
    page?: number,
    pageSize?: number,
  ) {
    let url = '/api/lab/getCompletedInventories';
    //startDate and endDate are moment objects
      if(startDate && endDate) {
        // Convert moment objects to SQL format
        const pad = (n: number) => n.toString().padStart(2, '0');
        const formatDate = (d: any, time: string) => {
          // If moment object, use format; else fallback to Date
          if (d && typeof d.format === 'function') {
            return d.format(`YYYY-MM-DD ${time}`);
          } else {
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${time}`;
          }
        };
        const startSql = formatDate(startDate, '00:00:00');
        const endSql = formatDate(endDate, '23:59:59');
        url += `/${startSql}/${endSql}`;
      }
    let params: any = {};
    if (page) {
      params.page = page;
    }
    if (pageSize) {
      params.pageSize = pageSize;
    }
    return this.http.get(url, { params: params });
  }

  getLabReports(byExam = true){
    let url = '/api/lab/getPatientReports/' + this.pat.getPat().PID + (byExam ? '/' + this.es.examID : '');
    return this.http.get(url);
  }

  assignLabReportToExam(LabReport: number){
    return this.http.post('/api/lab/assignLabReportToExam', {LabReport: LabReport, examId: this.es.examID});
  }

  searchMissingLabReports(startDate: Date, endDate: Date){
    const { startSql, endSql } = this.getSqlDateRange(startDate, endDate);
    let url = `/api/lab/unidentifiedLabResults/${startSql}/${endSql}`;
    return this.http.get(url);
  }

  updateBarcode(pathologyId: number, newBarcode: string){
    return this.http.post('/api/lab/savebarcode', {pathologyId: pathologyId, barcode: newBarcode});
  }

  getTodayPathologies(PID: number){
    return this.http.get('/api/lab/todayspathologies/' + PID);
  }

  removeSamplesFromInventory(inventoryId: number, pathologyIds: number[]){
    return this.http.post('/api/lab/removeSamplesFromInventory', {inventoryId: inventoryId, pathologyIds: pathologyIds});
  }

  removeSignature(inventoryId: number, userType: string) {
    return this.http.post("/api/lab/removeSignature", {
      inventoryId: inventoryId,
      userType: userType,
    });
  }
}